import React, { useState, useRef } from 'react';
import { Image, Upload } from 'lucide-react';

const ImageBlock = ({ block, onUpdate }) => {
  const fileInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setIsUploading(true);
    try {
      const reader = new FileReader();
      reader.onload = (event) => {
        onUpdate(block.id, {
          src: event.target?.result,
          fileName: file.name,
        });
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error('Error uploading image:', error);
    } finally {
      setIsUploading(false);
    }
  };

  const handleCaptionChange = (e) => {
    onUpdate(block.id, { caption: e.target.value });
  };

  const handleAltChange = (e) => {
    onUpdate(block.id, { alt: e.target.value });
  };

  const handleUrlChange = (e) => {
    onUpdate(block.id, { src: e.target.value });
  };

  return (
    <div className="image-block">
      {block.src ? (
        <div className="image-preview">
          <img src={block.src} alt={block.alt || 'Article image'} />
          <button
            onClick={() => onUpdate(block.id, { src: '', caption: '', alt: '' })}
            className="remove-image-btn"
          >
            Remove
          </button>
        </div>
      ) : (
        <div className="image-upload">
          <div className="upload-area">
            <Image size={32} />
            <p>Upload an image or paste a URL</p>
            <button
              onClick={() => fileInputRef.current?.click()}
              disabled={isUploading}
              className="upload-btn"
            >
              <Upload size={16} />
              {isUploading ? 'Uploading...' : 'Choose File'}
            </button>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
          </div>
          <div className="url-input">
            <input
              type="url"
              placeholder="Or paste image URL..."
              onChange={handleUrlChange}
              className="url-field"
            />
          </div>
        </div>
      )}

      {block.src && (
        <div className="image-meta">
          <input
            type="text"
            placeholder="Alt text (for accessibility)"
            value={block.alt || ''}
            onChange={handleAltChange}
            className="alt-input"
          />
          <textarea
            placeholder="Image caption (optional)"
            value={block.caption || ''}
            onChange={handleCaptionChange}
            className="caption-input"
            rows="2"
          />
        </div>
      )}
    </div>
  );
};

export default ImageBlock;
